import { showModal } from 'app/App.components/Modal/Modal.actions'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'reducers'

import { HomeView } from './Home.view'

export const Home = () => {
  const isDarkMode = useSelector((state: State) => state.darkMode)
  const dispatch = useDispatch()

  const showModalCb = (title: string, children: JSX.Element) => {
    dispatch(showModal(title, children))
  }
  return <HomeView isDarkMode={isDarkMode} showModal={showModalCb} />
}
